import React, { useEffect, useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Intermediate_Check_Report_Filter from "./intermediate_check_report_filter/Intermediate_Check_Report_Filter";
import Intermediate_Check_Report_Table from "./intermediate_check_report_table/Intermediate_Check_Report_Table";
import {
  GetCustomerReport,
  GetIntermediateReport,
} from "../../../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetAllIntermediate } from "../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Intermediate_Check_Report = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParams, setSearchParams] = useState({
    instrument_id: "",
    instrument_name: "",
    end_date: "",
    start_date: "",
  });

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(
    FixIDS.intermediate_check_report.Report,
  );

  const data = useSelector((state) => state.equipment.data);
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAllIntermediate({
        instrument_id: searchParams?.instrument_id,
        instrument_name: searchParams?.instrument_name,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
        page: page,
        // per_page: data?.data.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, searchParams, dispatch]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetIntermediateReport({
        instrument_id: searchParams?.instrument_id,
        instrument_name: searchParams?.instrument_name,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
        page: 1,
        // per_page: data?.data.per_page,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Intermediate_Check_Report_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Intermediate_Check_Report_Table
            data={data}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Intermediate Check Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Intermediate_Check_Report;
